import { useState, useCallback } from 'react';

import {
  Parameter$verifyReservationFlowResource,
  RequestBody$verifyReservationFlowResource,
} from '../../../../openapi/generated/apiClient';
import { fetchCsrfToken } from '../../../../infrastructure/api';
import {
  isAxiosError,
  useClientSideApiClient,
} from '../../../../openapi/axiosClient';

export interface UseVerifyReservationFlowResourceParams {
  parameter: Omit<Parameter$verifyReservationFlowResource, 'X-Csrf-Token'>;
}

export interface UseVerifyReservationFlowResourceValue {
  isValidating: boolean;
  verifyReservationFlowResource: (params: {
    values: RequestBody$verifyReservationFlowResource['application/json'];
  }) => Promise<{} | { error: { message: string } }>;
}

export const useVerifyReservationFlowResource: (
  params: UseVerifyReservationFlowResourceParams,
) => UseVerifyReservationFlowResourceValue = ({ parameter }) => {
  const apiClient = useClientSideApiClient();
  const [isValidating, setIsValidating] = useState(false);

  const verifyReservationFlowResource = useCallback<
    UseVerifyReservationFlowResourceValue['verifyReservationFlowResource']
  >(
    async ({ values }) => {
      setIsValidating(true);

      try {
        const csrfToken = await fetchCsrfToken();

        await apiClient.verifyReservationFlowResource({
          parameter: { ...parameter, 'X-Csrf-Token': csrfToken },
          requestBody: values,
        });

        setIsValidating(false);
        return {};
      } catch (error) {
        if (!isAxiosError(error) || typeof error.response === 'undefined') {
          setIsValidating(false);
          return { error: { message: '予期せぬエラーが発生しました' } };
        }

        const message =
          error.response.status === 401
            ? 'パスワードが違います。正しいパスワードを入力してください。'
            : '予期せぬエラーが発生しました';

        setIsValidating(false);
        return { error: { message } };
      }
    },
    [parameter, apiClient],
  );

  return { isValidating, verifyReservationFlowResource };
};
